export const BALANCE = Object.freeze({
  gameId: "littlecastle-defense",
  maximumLoadoutSlots: 5,
  wavePreparationMs: 12_000,
  earlyWaveRewardPerSecond: 1,
  enemySpawnPaddingMs: 300,
  defaultSpawnDurationMs: 520,
  defaultSpawnProtectionMs: 440,
  defaultDeathDurationMs: 540,
  defaultEscapeDurationMs: 360,
  defaultGameSpeed: 1,
  fastGameSpeed: 2,
  maximumFrameDeltaMs: 50,
  stressEnemyCount: 150,
  baseEnemyHealthMultiplier: 1.6,
  enemyHealthPerWave: 0.05,
  enemyHealthPerMap: 0.1,
  bossHealthMultiplier: 1.8,
  minibossHealthMultiplier: 1.35,
  minibossTowerUpgradeChance: 0.2,
  bossGoldMultiplier: 4,
  minibossGoldMultiplier: 2.5,
  scorePerLife: 100,
  scorePerWave: 500,
});
